import React from "react";
import Navbar from "./Navbar";
import Test from "./Test";
import Dashboard from "./Dashboard";
import Vendorslist from "./Vendorslist";
import Customerlist from "./Customerlist";
import Employeelist from "./Employeelist";
import ItemList from "./ItemList";
import InvoiceList from "./InvoiceList";
import Invoice from "./Invoice";
import InvoiceEdit from "./InvoiceEdit";
import Invoiceview from "./Invoiceview";
import Invoicerecordpayment from "./Invoicerecordpayment";
import InvoicerecordpaymentEdit from "./InvoicerecordpaymentEdit";
import InvoiceFeedbacklist from "./InvoiceFeedbacklist";
import InvoicefeedbackquestionList from "./InvoicefeedbackquestionList";
import Purchaseorderlist from "./Purchaseorderlist";
import Purchaseorder from "./Purchaseorder";
import Purchaseorderview from "./Purchaseorderview";
import PurchaseorderEdit from "./PurchaseorderEdit";
import Purchaseordertobill from "./Purchaseordertobill";
import LeadList from "./LeadList";
import Lead from "./Lead";
import BranchList from "./BranchList";
import WarehouseList from "./WarehouseList";
import Billslist from "./Billslist";
import BillEdit from "./BillEdit";
import Billview from "./Billview";
import Billcreate from "./Billcreate";
import Billrecordpaymentedit from "./Billrecordpaymentedit";
import Billrecordpayment from "./Billrecordpayment";
import ExpenseList from "./ExpenseList";
import DepositedList from "./DepositedList";
import InventorytranferList from "./InventorytranferList";
import InventoryadjustmentsList from "./InventoryadjustmentsList";
import LeadsourceList from "./LeadsourceList";
import LeadstatusList from "./LeadstatusList";
import BrandList from "./BrandList";
import ExpensecateList from "./ExpensecateList";
import Reasonlist from "./Reasonlist";
import Organizationprofile from "./Organizationprofile";
import Fiforeport from "./Fiforeport";
import ModeofpaymentList from "./ModeofpaymentList";
import ManufacturersList from "./ManufacturersList";
import ServicetypeList from "./ServicetypeList";
import CustomervehicleList from "./CustomervehicleList";
import FeedbackcallStatus from "./FeedbackcallStatus";
import FeedbackstatusList from "./FeedbackstatusList";
import Enquire from "./Enquire";
import EnquireList from "./EnquireList";
import EnquireView from "./EnquireView";
import EnquireEdit from "./EnquireEdit";
import CustomerratingoneList from "./CustomerratingoneList";
import CustomerratingtwoList from "./CustomerratingtwoList";
import Preferences from "./Preferences";
import CustomerprofileView from "./CustomerprofileView";

import Test1 from "./Test1";
import { Link, Navigate, useParams } from "react-router-dom";
class FilterBy extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      urlUpdate: true,
      urlUpdateV: "",
      id: 1,
    };

    this.subc = React.createRef();
  }

  handleCallback = (searchDate) => {
    if (this.subc.current != null) {
      this.subc.current.Search(searchDate);
    }
  };

  getSubComponet() {
    const { filterby } = this.props.params;
    const { id } = this.props.params;

    this.state.urlUpdateV = filterby;

    if (id != null) {
      if (filterby == "InvoiceEdit") {
        this.state.id = 5;
        return <InvoiceEdit ref={this.subc} />;
      }
      if (filterby == "Invoiceview") {
        this.state.id = 5;
        return <Invoiceview ref={this.subc} />;
      }
      if (filterby == "Invoicerecordpayment") {
        this.state.id = 5;
        return <Invoicerecordpayment ref={this.subc} />;
      }
      if (filterby == "InvoicerecordpaymentEdit") {
        this.state.id = 5;
        return <InvoicerecordpaymentEdit ref={this.subc} />;
      }

      if (filterby == "Purchaseorderview") {
        this.state.id = 6;
        return <Purchaseorderview ref={this.subc} />;
      }
      if (filterby == "Purchaseorderedit") {
        this.state.id = 6;
        return <PurchaseorderEdit ref={this.subc} />;
      }
      if (filterby == "Purchaseordertobill") {
        this.state.id = 6;
        return <Purchaseordertobill ref={this.subc} />;
      }

      if (filterby == "BillEdit") {
        this.state.id = 10;
        return <BillEdit ref={this.subc} />;
      }
      if (filterby == "Billview") {
        this.state.id = 10;
        return <Billview ref={this.subc} />;
      }
      if (filterby == "Billrecordpaymentedit") {
        this.state.id = 10;
        return <Billrecordpaymentedit ref={this.subc} />;
      }
      if (filterby == "Billrecordpayment") {
        this.state.id = 10;
        return <Billrecordpayment ref={this.subc} />;
      }

      if (filterby == "EnquireView") {
        console.log("as");
        this.state.id = 15;
        return <EnquireView ref={this.subc} />;
      }
      if (filterby == "EnquireEdit") {
        this.state.id = 15;
        return <EnquireEdit ref={this.subc} />;
      }
    }

    if (id == null) {
      if (filterby == "Dashboard") {
        this.state.id = 0;

        return <Dashboard ref={this.subc} />;
      }

      if (filterby == "Customerlist") {
        this.state.id = 1;
        return <Customerlist ref={this.subc} />;
      }
      if (filterby == "Vendorslist") {
        this.state.id = 2;
        return <Vendorslist ref={this.subc} />;
      }
      if (filterby == "Employeelist") {
        this.state.id = 3;
        return <Employeelist ref={this.subc} />;
      }
      if (filterby == "ItemList") {
        this.state.id = 4;
        return <ItemList ref={this.subc} />;
      }
      if (filterby == "Invoicelist") {
        this.state.id = 5;
        return <InvoiceList ref={this.subc} />;
      }
      if (filterby == "Invoice") {
        this.state.id = 5;
        return <Invoice ref={this.subc} />;
      }
      if (filterby == "InvoiceEdit") {
        this.state.id = 5;
        return <InvoiceEdit ref={this.subc} />;
      }
      if (filterby == "InvoiceFeedbacklist") {
        this.state.id = 555;
        return <InvoiceFeedbacklist ref={this.subc} />;
      }

      if (filterby == "Purchaseorderlist") {
        this.state.id = 6;
        return <Purchaseorderlist ref={this.subc} />;
      }
      if (filterby == "Purchaseorder") {
        this.state.id = 6;
        return <Purchaseorder ref={this.subc} />;
      }

      if (filterby == "Billslist") {
        this.state.id = 10;
        return <Billslist ref={this.subc} />;
      }
      if (filterby == "Billcreate") {
        this.state.id = 10;
        return <Billcreate ref={this.subc} />;
      }

      if (filterby == "LeadList") {
        this.state.id = 7;
        return <LeadList ref={this.subc} />;
      }
      if (filterby == "Lead") {
        this.state.id = 7;
        return <Lead ref={this.subc} />;
      }

      if (filterby == "BranchList") {
        this.state.id = 8;
        return <BranchList ref={this.subc} />;
      }
      if (filterby == "WarehouseList") {
        this.state.id = 9;
        return <WarehouseList ref={this.subc} />;
      }

      if (filterby == "ExpenseList") {
        this.state.id = 11;
        return <ExpenseList ref={this.subc} />;
      }
      if (filterby == "InventorytranferList") {
        this.state.id = 12;
        return <InventorytranferList ref={this.subc} />;
      }
      if (filterby == "InventoryadjustmentsList") {
        this.state.id = 13;
        return <InventoryadjustmentsList ref={this.subc} />;
      }
      if (filterby == "Fiforeport") {
        this.state.id = 14;
        return <Fiforeport ref={this.subc} />;
      }
      if (filterby == "LeadsourceList") {
        this.state.id = 15;
        return <LeadsourceList ref={this.subc} />;
      }
      if (filterby == "LeadstatusList") {
        this.state.id = 15;
        return <LeadstatusList ref={this.subc} />;
      }
      if (filterby == "BrandList") {
        this.state.id = 15;
        return <BrandList ref={this.subc} />;
      }
      if (filterby == "ManufacturersList") {
        this.state.id = 15;
        return <ManufacturersList ref={this.subc} />;
      }
      if (filterby == "ExpensecateList") {
        this.state.id = 15;
        return <ExpensecateList ref={this.subc} />;
      }
      if (filterby == "Reasonlist") {
        this.state.id = 15;
        return <Reasonlist ref={this.subc} />;
      }
      if (filterby == "ModeofpaymentList") {
        this.state.id = 15;
        return <ModeofpaymentList ref={this.subc} />;
      }

      if (filterby == "Organizationprofile") {
        this.state.id = 15;
        return <Organizationprofile ref={this.subc} />;
      }
      if (filterby == "InvoicefeedbackquestionList") {
        this.state.id = 16;
        return <InvoicefeedbackquestionList ref={this.subc} />;
      }
      if (filterby == "ServicetypeList") {
        this.state.id = 15;
        return <ServicetypeList ref={this.subc} />;
      }
      if (filterby == "CustomervehicleList") {
        this.state.id = 15;
        return <CustomervehicleList ref={this.subc} />;
      }
      if (filterby == "FeedbackcallStatus") {
        this.state.id = 15;
        return <FeedbackcallStatus ref={this.subc} />;
      }
      if (filterby == "FeedbackcallStatus") {
        this.state.id = 15;
        return <FeedbackcallStatus ref={this.subc} />;
      }
      if (filterby == "FeedbackstatusList") {
        this.state.id = 15;
        return <FeedbackstatusList ref={this.subc} />;
      }
      if (filterby == "Enquire") {
        this.state.id = 15;
        return <Enquire ref={this.subc} />;
      }
      if (filterby == "EnquireList") {
        this.state.id = 15;
        return <EnquireList ref={this.subc} />;
      }
      if (filterby == "CustomerratingoneList") {
        this.state.id = 15;
        return <CustomerratingoneList ref={this.subc} />;
      }
      if (filterby == "CustomerratingtwoList") {
        this.state.id = 15;
        return <CustomerratingtwoList ref={this.subc} />;
      }
      if (filterby == "Preferences") {
        this.state.id = 17;
        return <Preferences ref={this.subc} />;
      }
      if (filterby == "DepositedList") {
        this.state.id = 17;
        return <DepositedList ref={this.subc} />;
      }

      if (filterby == "Customerprofileview") {
        this.state.id = 17;
        return <CustomerprofileView ref={this.subc} />;
      }

      
      if (filterby == "Test") {
        this.state.id = 17;
        return <Test ref={this.subc} />;
      }
    }
  }

  componentWillReceiveProps(nextProps) {
    if (this.state.urlUpdate) {
      this.setState({ urlUpdate: false });
    } else {
      this.setState({ urlUpdate: true });
    }
  }

  /*componentDidUpdate(prevProps, prevState, snapshot) {

      
        if(this.state.urlUpdate){

            this.setState({ urlUpdate:false });

        }else{

            this.setState({ urlUpdate:true });
        }
      
    }*/

  render() {
    return (
      <div>
        {this.state.urlUpdate && (
          <Navbar
            navData={this.getSubComponet()}
            navId={this.state.id}
            navCallback={this.handleCallback}
          />
        )}

        {!this.state.urlUpdate && (
          <Navbar
            navData={this.getSubComponet()}
            navId={this.state.id}
            navCallback={this.handleCallback}
          />
        )}
      </div>
    );
  }
}
export default (props) => <FilterBy {...props} params={useParams()} />;
